<template>
    <pagination-component :page-count="pageCount" @select-page="selectPage($event)" :current-page="currentPage"></pagination-component>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PaginationComponent from './PaginationComponent';

export default {
  name: 'Pagination',
  components: {
    PaginationComponent
  },
  computed: mapState({
    currentPage: state => state.currentPage,
    pageCount: state => state.pageCount
  }),
  methods: {
    ...mapActions([
      'selectPage'
    ])
  }
};
</script>

<style scoped>
    .pagination li{
        cursor: pointer;
    }
</style>
